<template>
  <div class="help-page">
    <!-- 顶部导航栏 -->
        <div class="page-header">
      <button class="back-btn" @click="$router.back()">返回</button>
      <h2 class="page-title">关于本系统</h2>
      <span class="feedback-btn" @click="openFeedback">联系客服</span>
      </div>

    <!-- Tab标签栏 -->
    <div class="tabs-wrap">
      <div 
        class="tab-item" 
        :class="{active: activeTab === 'intro'}"
        @click="activeTab = 'intro'"
      >系统介绍</div>
      <div 
        class="tab-item" 
        :class="{active: activeTab === 'agreement'}"
        @click="activeTab = 'agreement'"
      >使用协议</div>
      <div 
        class="tab-item" 
        :class="{active: activeTab === 'privacy'}"
        @click="activeTab = 'privacy'"
      >隐私政策</div>
    </div>

    <!-- 主体内容区域，可滚动 -->
    <div class="content-wrap">
      <div class="content-card">
        <!-- 标签1：系统介绍（原有全部内容原样保留） -->
        <div v-if="activeTab === 'intro'">
          <div class="title-area">

          <!-- 新增：横向新手引导流程图 -->
          <div class="guide-section">
            <h3 class="guide-title">开启你的印记之旅</h3>
            
            <div class="guide-grid">
              <!-- 步骤 1 -->
              <div class="guide-card">
                <div class="card-header">
                  <div class="step-num">1</div>
                  <h4>注册与登录</h4>
                </div>
                <p>手机号快捷注册，开启你的私密空间。</p>
              </div>

              <!-- 步骤 2 -->
              <div class="guide-card">
                <div class="card-header">
                  <div class="step-num">2</div>
                 <h4>创建/加入小组</h4>
                </div>
                <p>去<b>【个人中心】</b>创建小组或加入亲友的小组。</p>
              </div>

              <!-- 步骤 3 -->
              <div class="guide-card">
                <div class="card-header">
                  <div class="step-num">3</div>
                  <h4>点亮足迹地图</h4>
                </div>
                <p>在首页点击地图完成登记，地图将自动点亮。</p>
              </div>

              <!-- 步骤 4 -->
              <div class="guide-card">
                <div class="card-header">
                  <div class="step-num">4</div>
                  <h4>切换角色与珍藏</h4>
                </div>
                <p>首页<b>【角色切换】</b>查看不同角色的点亮地图。</p>
              </div>
            </div>            
            <div class="guide-tips">
              💡 <b>小贴士：</b>别人看不见你，你看不见别人。你能看到的只有你自己！和你爱的人！
            </div>
          </div>
<div style="text-align: center; margin-bottom: 20px;">
<h2 style="color: #FAB8CF; font-size: 20px; font-weight: bold; margin: 0; padding: 0; display: inline-block; 
           text-shadow: 1px 1px 0 #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 0 2px 4px rgba(0,0,0,0.1);">
  爱的印记
</h2>
  <span style="color: #666; font-size: 12px; font-weight: bold; margin-left: 12px; display: inline-block;">
    —— 爱，以足迹为证，有爱，有陪伴！
  </span>
 </div>
 </div>

          <p class="intro-paragraph">本系统，用以珍藏你与恋人、子女、长辈、亲友同行的足迹。把一段段相伴的时光妥帖留存，往后岁月随时回望旅途旧事，重温当时的心境与点滴感动，留住一路成长、彼此陪伴的温柔印记。</p>
          <ul>
            <li>
              <b>小组是什么？</b><br>
              小组是你和亲友的专属空间，分为：恋人伴侣、亲子、伴老、同学、朋友、亲戚、同事等类型。
              一条足迹归属某个小组，代表这条旅途是你和这个小组亲友共同出行的足迹，也是你们情感的印记。
            </li>
            <li>
              <b>个人足迹</b><br>
              不归属任何小组，仅属于你本人自己独立的足迹记录。
            </li>
            <li>
              <b>角色切换</b><br>
              在首页底部可以切换查看视角：个人 / 孝亲伴老 / 同学等小组。切换后，地图仅展示当前选中视角的足迹，并点亮足迹到达过的中国地图。
            </li>
            <li>
              <b>登记旅途足迹</b><br>
              点击地图省份、城市，可新增（补登）足迹。省份、城市、已自动填入，完善例如抵达/离开时间、同行人、景点、美食、旅途随笔等信息，还可上传旅途照片。
              如果你已创建小组，表单内【记录归属】下拉框，选择这条记录归「个人」或是你已创建的某个小组。
            </li>
            <li>
              <b>地图自动点亮</b><br>
              足迹保存成功后，全国地图自动点亮对应省份；进入省份详情页，省内到访城市也会点亮。
              不同角色视角，地图点亮的地域会不一样，由足迹归属决定。
            </li>
            <li>
              <b>省份详情查看</b><br>
              点击地图上任意已点亮省份，可进入该省页面，查看该省份下全部登记的每一条城市足迹。
            </li>
          </ul>

                    <b>特别提示</b>
          <p>本系统重视你的数据安全与隐私，我们采取了以下技术措施：</p>
          <ul>
            <li style="color:#d83030;"><b>账号密码加密存储</b>：你的登录密码采用 bcrypt 单向散列算法加密保存，任何人（包括系统运维人员）都无法还原出原始密码；</li>
            <li style="color:#d83030;"><b>传输加密</b>：上线后全站采用 HTTPS 加密传输，防止数据在传输过程中被窃听；</li>
            <li style="color:#d83030;"><b>账号隔离</b>：每个账号的手机号、密码、个人资料相互独立，其他用户无法访问你的账号信息；</li>
            <li style="color:#d83030;"><b>小组隔离</b>：个人足迹仅你本人可见；小组足迹仅该小组成员内部可见，不同小组之间的数据完全隔离，其他小组无法查看本组记录。所有用户的所有足迹都不会在本系统公开展示。</li>
          </ul>

          <p>请留意以下使用规则：</p>
          <ul>
            <li>足迹归属一旦保存，这条记录就固定归属所选小组/个人，用于区分不同场景不同角色的印记。足迹登记时须特别留意所登记信息的归属小组。</li>
            <li>小组内所有成员可以查看本组全部足迹；每位成员都可以补充、完善本组足迹的内容；只有该足迹的原登记人和小组组长有删除权限。</li>
            <li>角色切换只是切换查看视角，不会修改你的足迹数据。</li>
            <li>小组不存在时，切换到该小组会自动切回个人模式，并弹出提示。</li>
            <li>仅填写过足迹的省份、城市才会在地图点亮；只创建小组，不新增足迹，地图不会点亮。</li>
            <li>本系统为家庭、情侣、亲友之间的私人足迹记录工具，<b>并非公开社交平台</b>，请勿在小组内发布违法违规内容或商业推广信息。</li>
          </ul>
<div class="footer-beian" style="text-align: center; margin-top: 30px; padding-bottom: 20px; font-size: 11px; color: #999; line-height: 1.8;">
  <span>©2026 爱的印记 版权所有</span><br>
  <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #999; text-decoration: none;">渝ICP备2026026526号</a>
</div>
        </div>

        <!-- 标签2：用户使用协议 -->
        <div v-if="activeTab === 'agreement'" class="doc-content">
          <h4>《爱的印记》用户使用协议</h4>
          <p class="update-date">更新日期：2026年10月15日</p>
          <p>欢迎使用【爱的印记】（下称“本系统”）！在注册账号、访问和使用本系统服务前，请您仔细阅读本《用户使用协议》以及配套《隐私政策》。<strong>一旦您点击“同意”、注册账号、登录、浏览或使用本系统任何功能，即表示您已充分阅读、理解并自愿接受本协议全部条款约束。若您不同意本协议任何内容，请立即停止注册、退出并停止使用本系统。</strong></p>
          <p>本协议是您与本系统运营方之间，关于使用【爱的印记】各项服务所订立的有效合约。</p>

                    <p><b>第一条 服务内容</b></p>
          <p>1. 本系统提供 H5 网页服务，支持用户注册账号、填写个人资料、记录地域足迹、创建/加入小组、查看组内足迹、生成足迹海报、提交意见反馈等功能。</p>
          <p>2. 系统仅提供信息存储与展示的技术服务，不对用户发布内容的真实性、准确性、完整性做担保。</p>
          <p>3. 系统保留随时调整、修改、暂停、终止部分或全部功能的权利。功能调整时，系统将提前 7 日在页面公示或通过应用内通知方式告知用户。</p>

          <p><b>第二条 用户注册与账号</b></p>
          <p>1. 用户注册须提供本人有效手机号作为账号标识，保证注册信息真实、有效，不得冒用他人手机号、身份信息注册。禁止批量注册、刷号。</p>
          <p>2. 账号密码、登录Token由用户自行保管，因用户保管不善、转借账号、泄露登录凭证所造成的一切损失，全部由用户自行承担。</p>
          <p>3. 一个手机号仅限注册一个普通用户账号。用户不得转让、售卖、租借账号。系统有权对异常账号进行限制登录、封禁处理。</p>
          <p>4. 用户是账号下一切操作行为的责任人；账号下所有发布、留言、提交的数据，均视为账号本人操作。</p>

          <p><b>第三条 用户行为规范</b></p>
          <p>您承诺在使用本系统时，不得利用本系统发布、存储、传播下列内容：</p>
          <ul>
            <li>违反法律法规、公序良俗，涉及危害国家安全、宣扬恐怖、暴力、色情、赌博、毒品的信息；</li>
            <li>造谣、诽谤、侮辱、谩骂他人，侵犯他人名誉权、肖像权、隐私权、著作权等知识产权及其他合法权益；</li>
            <li>虚假诈骗信息、广告营销、引流外链、骚扰信息；</li>
            <li>非法收集、泄露其他用户手机号、个人隐私信息；</li>
            <li>恶意攻击、爬虫、破解系统接口，干扰服务器正常运行。</li>
          </ul>
          <p>一旦系统发现用户存在上述违规行为：系统有权不经事先通知，直接删除违规内容、限制功能、冻结或永久封禁账号。因用户违规行为造成第三方索赔、行政处罚、民事诉讼的，全部责任由该用户自行承担；如系统因此遭受损失，系统有权向该用户追偿。</p>

          <p><b>第四条 用户上传内容（足迹、文字、图片等）</b></p>
          <p>1. 用户在系统上传、提交的文字、备注、图片等内容（足迹备注、小组留言等），上传内容的著作权归原用户所有。</p>
          <p>2. 用户承诺：上传内容不侵犯任何第三方的知识产权、肖像权、隐私权等权利。如果第三方就用户上传内容向系统发起投诉、索赔，由发布该内容的用户独立承担全部法律责任。</p>
                  <p>3. 用户授予系统一项免费、非独占、可存储、可展示、可统计的技术授权，用于：① 实现足迹记录、地图点亮、小组展示等核心功能；② 系统故障排查、安全防护、异常行为识别；③ 为用户提供数据统计、排行榜、海报生成等衍生服务；④ 在匿名化、去标识化处理后的产品优化与数据分析。<b>系统不会超出本服务目的对外出售、转让、公开披露用户内容。</b></p>
          <p>4. 系统内置内容安全审核能力（文本/图片审核），但不承诺能够100%识别所有违规内容。系统仅在收到有效侵权投诉、监管通知后，对违规内容进行下架处理。</p>

          <p><b>第五条 免责声明</b></p>
          <p>1. 系统仅提供技术存储展示服务，不是内容的发布者。所有足迹文字、留言、资料均由用户自行填写上传，系统不对任何用户内容承担保证责任。</p>
                    <p>2. 用户通过本系统加入小组、与组内其他成员沟通、结伴出行、线下会面等，均为用户个人自愿行为。系统不参与、不组织任何线下活动，不对任何线下出行、会面产生的人身伤害、财产损失承担任何赔偿责任。用户应自行评估风险，做好个人安全防护。</p>
          <p>3. 因不可抗力（地震、网络中断、运营商故障、服务器宕机、黑客攻击、监管要求）造成服务临时中断、数据短暂无法访问，系统在合理范围内尽力恢复，不承担由此带来的损失赔偿。</p>
          <p>4. 用户理解：互联网存储存在极小概率数据丢失风险。重要数据建议用户自行本地备份，系统不承诺永久无差错保存用户全部数据。</p>
          <p>5. 本系统不对用户之间的纠纷（小组矛盾、成员争执、经济往来等）进行强制裁决；用户之间的纠纷，由各方自行协商或通过司法途径解决，系统无义务介入。</p>

                   <p><b>第六条 个人信息保护</b></p>
          <p>用户的个人信息保护，以配套《隐私政策》为准。系统仅收集必要信息用于登录、功能使用；未经用户许可，不会向无关第三方出售用户个人信息。用户同意：系统可按法律法规、公安、监管机关的合法要求，配合提供相关账号信息。</p>

          <p><b>第七条 未成年人使用条款</b></p>
          <p>1. 本系统面向 18 周岁以上的成年人用户。若您未满 18 周岁，请在监护人陪同下阅读本协议，并在取得监护人同意后使用本系统。</p>
          <p>2. 本系统拒绝向未成年人提供使用服务。监护人应妥善保管自己的账号信息，严禁儿童使用本系统并对自身账号信息被儿童使用的行为承担责任。</p>
          <p>3. 若系统发现注册用户为未成年人，系统有权暂停或注销该账号。</p>

          <p><b>第八条 协议修改</b></p>
          <p>系统可以根据法律更新、业务调整修改本协议。修改后的协议在页面公示即生效。继续使用服务代表您接受修改后的协议；如不接受，您应当停止使用本系统并注销账号。</p>

          <p><b>第九条 账号注销、服务终止</b></p>
          <p>1. 用户可申请注销账号；注销后，系统会按隐私政策处理您的个人数据。</p>
          <p>2. 用户严重违反本协议，系统有权直接终止服务、封禁账号。</p>
                    <p>3. 系统有权整体停止项目运营。停止运营前，系统将<b>提前至少 30 日</b>通过应用内公告或页面公示方式通知用户，并为用户提供数据导出或备份的合理期限。</p>

          <p><b>第十条 争议解决</b></p>
          <p>1. 本协议适用中华人民共和国法律。</p>
          <p>2. 您和系统发生争议，优先友好协商；协商不成，双方同意向系统运营主体所在地人民法院提起诉讼。</p>

          <p><b>第十一条 其他</b></p>
          <p>1. 本协议构成双方完整约定，取代此前口头或其他沟通内容。</p>
          <p>2. 协议部分条款被认定无效，不影响其余条款效力。</p>
        </div>

        <!-- 标签3：隐私政策 -->
        <div v-if="activeTab === 'privacy'" class="doc-content">
          <h4>《爱的印记》隐私政策</h4>
          <p class="update-date">更新日期：2026年10月15日</p>
          <p>本隐私政策旨在向您说明【爱的印记】如何收集、存储、使用、保护您的个人信息。在使用本系统前，请仔细阅读本政策。使用本系统，即代表您同意按照本政策收集和使用您的信息。</p>

          <p><b>一、我们收集哪些信息</b></p>
          <p>1. <b>账号信息：手机号</b>。用于注册、登录账号，验证用户身份，找回账号。手机号为系统必要收集项，不收集无法注册使用系统。</p>
          <p>2. <b>用户资料信息</b>：您主动填写的昵称、头像、个性签名，由用户自愿填写。</p>
          <p>3. <b>足迹记录信息</b>：您主动录入的省份、城市、旅途时间、随笔文字、上传图片、小组归属等内容。所有内容由您自主提交，<b>在您注册并勾选同意《用户协议》与《隐私政策》的前提下，您主动提交该等信息，即表明您已单独同意系统登记及留存您的行踪轨迹信息</b>。</p>
          <p>4. <b>日志信息</b>：访问时间、浏览器型号、网络信息，用于排查系统故障、保障系统安全。</p>

                    <p><b>二、信息如何存储与保护</b></p>
          <p>我们采用以下技术措施保护您的信息安全：</p>
          <ul>
            <li><strong>密码加密</strong>：您的账号密码采用 bcrypt 单向散列算法加密保存，任何人无法还原原始密码；</li>
            <li><strong>传输加密</strong>：全站采用 HTTPS 协议加密传输，防止数据在传输链路中被窃听或篡改；</li>
            <li><strong>访问控制</strong>：系统设有账号密码校验、JWT Token 鉴权、接口限流、滑块验证等多层防护，防止账号被暴力破解或接口被滥用；</li>
            <li><strong>数据隔离</strong>：个人足迹仅本人账号可见；小组内足迹仅该小组的成员可以查看；不同小组的数据相互隔离，其他小组或用户无法查看本组记录；对于行踪轨迹等敏感个人信息的处理，我们已依法开展个人信息保护影响评估。</li>
            <li><strong>操作权限</strong>：系统对用户的操作行为进行权限校验，防止越权访问、越权修改他人数据。</li>
          </ul>
          <p>我们承诺：不会主动向任何第三方出售、出租或公开您的个人信息，法律法规另有规定除外。本系统服务器位于中国境内，我们不会将您的个人信息传输至境外。</p>

          <p><b>三、信息使用目的</b></p>
          <ul>
            <li>用于账号注册、登录、身份校验，保障账号安全；</li>
            <li>提供足迹记录、地图点亮、小组管理、内容展示、海报生成等核心功能；</li>
            <li>系统故障排查、安全防护、异常行为识别、抵御网络攻击；</li>
            <li>为提升服务体验，对用户行为数据进行<b>匿名化、去标识化</b>统计分析（不会识别到具体个人）；</li>
            <li>遵守法律法规，响应监管、公安、法院等有权机关的合法查询要求。</li>
          </ul>
          <p>我们<strong>不会出售、出租您的个人信息</strong>。除非取得您单独同意、或法律法规强制要求，不会向无关第三方共享您的个人信息。</p>

          <p><b>四、内容安全审核</b></p>
          <p>为遵守《网络安全法》《互联网信息服务管理办法》等法律法规，您上传的文本内容会经过敏感词过滤预审，防止违法违规信息传播。审核仅针对是否违规进行判断，不会用于其他目的。</p>

          <p><b>五、您的权利</b></p>
          <ul>
            <li><b>访问/查看</b>：您可随时查看自己的个人资料、全部足迹记录；</li>
            <li><b>修改</b>：您可以修改昵称、头像、签名，编辑、修改自己登记的足迹；</li>
            <li><b>删除</b>：您可以删除自己登记的足迹，小组组长可删除本组全部足迹；</li>
            <li><b>账号注销</b>：您可以通过意见反馈渠道申请注销账号，我们将在 <b>15 个工作日</b>内处理完毕；</li>
            <li><b>撤回同意</b>：您可以随时停止使用本系统并申请注销账号，撤回对个人信息的收集同意。</li>
          </ul>
          <p>如您对个人信息处理有任何疑问、投诉或申请，可通过页面右上角「联系客服」功能提交，<b>我们将在 15 个工作日内响应处理</b>。</p>

          <p><b>六、数据保存期限</b></p>
          <p>1. 在您账号存续期间，系统保存您的业务数据；</p>
          <p>2. 您申请注销账号后，我们将在 <b>15 个工作日</b>内完成账号注销，并在 <b>30 个自然日</b>内删除或匿名化处理您的个人信息，但下列信息除外：</p>
          <ul>
            <li>法律法规要求留存的信息（如交易记录、操作日志等，留存期限以法律规定为准）；</li>
            <li>为配合监管、公安、法院等有权机关调查所需的信息。</li>
          </ul>

          <p><b>七、未成年人保护</b></p>
          <p>本系统不向未满 18 周岁的未成年人提供服务。我们不会主动收集未成年人的个人信息。若我们发现在未获监护人同意的情况下收集了未成年人的个人信息，我们将依法尽快删除相关数据。若您是未成年人的监护人，当您对被监护人的个人信息有疑问时，请通过本政策公布的联系方式与我们联系。</p>

          <p><b>八、数据安全事件通知</b></p>
          <p>若发生个人信息泄露、篡改、丢失等安全事件，我们将按法律法规要求，及时以应用内通知、公告等方式告知您：事件基本情况、可能影响、我们已采取的处置措施、您可自主防范的建议等，并按要求向监管部门报告。</p>

          <p><b>九、Cookie 及本地存储使用</b></p>
          <p>为保障服务正常运行，本系统目前不使用 Cookie 进行追踪或广告投放，本系统会使用浏览器本地存储（localStorage）保存您的登录 Token、界面偏好设置等信息。这些信息不会用于广告推送，您也可以通过清除浏览器数据来删除这些信息（但可能影响登录状态）。</p>

          <p><b>十、隐私政策更新</b></p>
          <p>本政策可能随法律法规更新或业务调整而修改。重大变更时，我们会通过应用内公告、弹窗等方式显著提示。继续使用本系统代表您接受更新后的隐私政策。</p>

          <p><b>十一、联系我们</b></p>
          <p>如您对本隐私政策有任何疑问、意见或投诉，或者有账号注销、数据删除等需求，可通过以下方式联系我们处理：</p>
          <ul>
            <li><b>应用内反馈</b>：首页 → 帮助 → 联系客服（推荐）</li>
            <li><b>电子邮箱</b>：service@aiyinji.cn（我们已指定个人信息保护负责人，您可通过上述邮箱与其取得联系）</li>
          </ul>
          <p>特别说明：如您申请注销账号，我们将在收到您的有效申请后 <b>15 个工作日内</b>为您完成注销处理，并按本政策规定删除或匿名化您的个人信息。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelpDescription",
  data() {
    return {
      activeTab: 'intro'
    }
  },
  mounted() {
    // 支持通过 URL 直接打开指定 tab：/help?tab=agreement 或 /help?tab=privacy
    const tab = this.$route.query.tab
    if (tab === 'agreement' || tab === 'privacy' || tab === 'intro') {
      this.activeTab = tab
    }
  },
  watch: {
    '$route.query.tab'(newTab) {
      if (newTab === 'agreement' || newTab === 'privacy' || newTab === 'intro') {
        this.activeTab = newTab
      }
    }
  },
  methods: {
    openFeedback() {
      if (typeof window !== 'undefined' && typeof window.__openFeedback === 'function') {
        window.__openFeedback()
      }
    }
  }
}
</script>

<style scoped>
/* ============================================================
   1. 页面骨架
   ============================================================ */
.help-page {
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  width: 100%;
  font-family: "Microsoft YaHei UI", "Microsoft YaHei", SimHei, sans-serif;
  color: #333;
  
  /* 统一全站云纹背景 */
  background-image: url("~@/assets/subtle.webp");
  background-repeat: repeat;
  background-size: 500px auto;
  background-position: center;
  background-color: rgba(247, 243, 233, 0.55);
}

/* ============================================================
   2. Header：高光玻璃导航（自适应三分法）
   ============================================================ */
.page-header {
  position: relative;
  z-index: 10;
  flex-shrink: 0;
  height: clamp(48px, 7vh, 68px); 
  display: flex;
  align-items: center;
  justify-content: space-between; /* 👈 左右两端对齐 */
  padding: 0 clamp(16px, 3vw, 24px); 
  box-sizing: border-box;
  
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.05));
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

/* 左侧返回键：纯白微光胶囊 */
.back-btn {
  border-radius: 6px; 
  padding: 0 clamp(8px, 1.2vw, 14px); 
  height: clamp(24px, 3.2vh, 28px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.15));
  color: #fff;
  font-weight: 600;
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1), inset 0 1px 2px rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(4px);
  font-size: clamp(11px, 1.1vw, 14px);
  line-height: 1.2; 
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.2s ease;
  text-shadow: 0 1px 2px rgba(0,0,0,0.15);
}
.back-btn:hover {
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.3));
  transform: translateY(-1px);
}
.back-btn:active {
  transform: translateY(1px) scale(0.96);
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.15);
}

/* 中间标题：击穿全局的纯白浮雕发光字 */
.page-title,
div.page-header h2 {
  position: absolute !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  margin: 0 !important;
  color: #2c3e50 !important; 
  
  font-size: clamp(16px, 2.1vw, 22px) !important; 
  font-weight: 900 !important; 
  letter-spacing: 3px !important; 
  white-space: nowrap !important;
  pointer-events: none !important;
  line-height: 1.2 !important;
  
  /* 👇 核心：三重发光阴影，完美复刻个人中心 */
  text-shadow: 
    0 2px 4px rgba(255, 255, 255, 0.9),
    0 4px 12px rgba(255, 255, 255, 0.6),
    0 1px 0px rgba(255, 255, 255, 1) !important;
}

/* 右侧联系客服：完美复刻返回键大小，保留粉红色 */
.feedback-btn {
  border-radius: 6px; 
  padding: 0 clamp(8px, 1.2vw, 14px); 
  height: clamp(24px, 3.2vh, 28px); 
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: clamp(10px, 1vw, 13px);
  line-height: 1.2; 
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.2s ease;
  white-space: nowrap;
  text-shadow: 0 1px 2px rgba(0,0,0,0.15);
  
  /* 👇 颜色保持你想要的粉红高光琉璃 */
  color: #fff;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0) 50%), rgba(214, 72, 107, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow: 0 2px 6px rgba(214, 72, 107, 0.25), inset 0 1px 2px rgba(255, 255, 255, 0.5);
}
.feedback-btn:hover {
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.35), rgba(255, 255, 255, 0) 50%), rgba(214, 72, 107, 0.95);
  transform: translateY(-1px);
}
.feedback-btn:active {
  transform: translateY(1px) scale(0.96);
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* ============================================================
   3. Tabs 标签栏
   ============================================================ */
.tabs-wrap {
  display: flex;
  background: transparent;
  flex-shrink: 0;
  padding: 0 clamp(10px, 2vw, 20px);
  margin-top: 0;
}

.tab-item {
  flex: 1;
  text-align: center;
  padding: clamp(6px, 1vh, 10px) 0;
  font-size: clamp(13px, 1.5vw, 16px);
  font-weight: 600;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  color: #666;
  transition: all 0.2s;
}

.tab-item.active {
  border-bottom: 3px solid #d6486b;
  color: #d6486b;
  font-weight: 800;
}

/* ============================================================
   4. 内容卡片与正文
   ============================================================ */
.content-wrap {
  flex: 1;
  overflow-y: auto;
  padding: clamp(6px, 1.5vw, 12px) clamp(10px, 2vw, 20px) clamp(10px, 2vw, 20px);
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
}

.content-card {
  background: rgba(255, 255, 255, 0.45); 
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.8);
  box-shadow: 
    0 8px 24px rgba(0, 0, 0, 0.08), 
    0 2px 6px rgba(0, 0, 0, 0.04),
    inset 0 1px 2px rgba(255, 255, 255, 0.9);
  border-radius: 16px;
  padding: clamp(15px, 3vw, 28px);
  max-width: 800px;
  margin: 0 auto;
}

.title-area {
  text-align: center;
  margin-bottom: 12px;
}

.content-card p, 
.content-card li {
  color: #444;
  line-height: 1.7;
  font-size: clamp(13px, 1.5vw, 15px); 
  margin-bottom: 0.5em;
}

.content-card h4 {
  margin: clamp(16px, 3vh, 24px) 0 8px;
  color: #2c3e50;
  font-size: clamp(15px, 1.8vw, 16px);
}
.content-card ul, .content-card ol{
  padding-left:22px;
  margin:6px 0;
}
.content-card li{
  margin-bottom:10px;
}
.intro-paragraph {
  text-indent: 2em; /*首行空2个汉字*/
}
.update-date{
  color:#888;
  font-size:13px;
  margin:4px 0 16px;
}
.doc-content p strong{
  color:#2c3e50;
}

/* ============================================================
   5. 横向新手引导流程图
   ============================================================ */
.guide-section {
  margin: 0 0 16px; 
  padding: clamp(12px, 2vw, 16px) clamp(12px, 2vw, 20px);
  background: rgba(255, 255, 255, 0.4);
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.8);
}

.guide-title {
  text-align: center;
  font-size: clamp(16px, 2vw, 20px);
  color: #d6486b;
  margin-bottom: 10px;
  font-weight: bold;
  font-family: "STXingkai", "KaiTi", sans-serif;
}

/* 强制四列网格 */
.guide-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr); 
  gap: clamp(6px, 1vw, 12px);
}

.guide-card {
  background: rgba(255, 255, 255, 0.85);
  border-radius: 12px;
  padding: 8px 10px; 
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.9);
  transition: transform 0.2s;
  display: flex;
  flex-direction: column;
}
.guide-card:hover {
  transform: translateY(-2px);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}

.step-num {
  width: 18px;
  height: 18px;
  background: #f6b8cc;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: bold;
  flex-shrink: 0;
}

.guide-card h4 {
  margin: 0;
  font-size: clamp(12px, 1.2vw, 14px);
  color: #333;
  font-weight: 600;
}

.guide-card p {
  margin: 0;
  font-size: clamp(11px, 1vw, 13px); 
  color: #555;
  line-height: 1.5;
  text-align: left; 
  word-break: break-all; 
}
.guide-card p b {
  color: #d6486b;
  font-weight: 600;
}

.guide-tips {
  margin-top: 12px;
  padding: 8px 12px;
  background: rgba(253, 246, 236, 0.8); 
  border-radius: 8px;
  font-size: 12px;
  color: #b88230;
  line-height: 1.5;
  border: 1px solid rgba(250, 236, 216, 0.9);
}
.guide-tips b {
  color: #b88230;
}

/* ============================================================
   6. 底部版权和电脑端优化
   ============================================================ */
.footer-beian {
  text-align: center; 
  margin-top: 30px; 
  padding-bottom: 20px; 
  font-size: 11px; 
  color: #999; 
  line-height: 1.8;
}
.footer-beian a {
  color: #999; 
  text-decoration: none;
}
.footer-beian a:hover {
  text-decoration: underline;
}

/* 针对电脑端（屏幕宽度 >= 1024px）单独缩小正文 */
@media screen and (min-width: 1024px) {
  .content-card p, 
  .content-card li {
    font-size: 13px !important; 
    line-height: 1.6 !important;
  }
  .content-card h4 {
    font-size: 15px !important;
  }
}
</style>